import { render, staticRenderFns } from "./Insure.vue?vue&type=template&id=13f38ac6&"
import script from "./Insure.vue?vue&type=script&lang=js&"
export * from "./Insure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports